import { render, staticRenderFns } from "./contentUserEdit.vue?vue&type=template&id=63f588c8&"
import script from "./contentUserEdit.vue?vue&type=script&lang=js&"
export * from "./contentUserEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports